import { useContext, useEffect, useState } from "react";
import { AuthType } from "../../shared/constants/AppEnums";
import { defaultUser } from "../../shared/constants/AppConst";
import jwtAxios from "../services/ApiConfig";
import { AuthUser } from "../../types/models/AuthUser";
import { fetchStart, fetchSuccess, useInfoViewActionsContext } from "../core/InfoView/InfoViewContext";
import AppContext from "./AppContext";
import AppContextPropsType from "../../types/AppContextPropsType";

export const useAuthToken = (): [boolean, AuthUser | null] => {
  const [loading, setLoading] = useState(true);
  const { user, updateAuthUser } = useContext<AppContextPropsType>(AppContext);
  const dispatch = useInfoViewActionsContext()!;
  useEffect(() => {
    const validateAuth = async () => {
      dispatch(fetchStart());
      let PatientDetails = localStorage.getItem('PatientDetails');
      let token = '';
      let userdetails: any;
      if (PatientDetails) {
        userdetails = JSON.parse(PatientDetails);
        token = userdetails['identificationKey'];
      }



      //  let token = userdetails['identificationKey'];

      // localStorage.setItem("PractitionerDetails", JSON.stringify(response.data.details));

      // console.log("token::", token);
      if (!token) {
        dispatch(fetchSuccess());
        return;
      }
      // console.log("token1::", token);
      jwtAxios.defaults.headers.common['x-auth-token'] = token;
      try {
        // console.log("token2::", token);
        //const res = await jwtAxios.get('/auth');
        // console.log("token3::", token);
        //  dispatch(fetchSuccess());
        updateAuthUser({
          authType: AuthType.JWT_AUTH,
          displayName: userdetails['firstName'],
          email: userdetails['email'],
          role: ['user', 'admin'],
          token: token,
          uid: userdetails['docid'],
          photoURL: userdetails['photo'],
        });
        return;
      } catch (err) {
        //  dispatch(fetchSuccess());
        return;
      }
    };

    const checkAuth = () => {
      Promise.all([validateAuth()]).then(() => {
        setLoading(false);
      });
    };
    checkAuth();
  }, [dispatch, updateAuthUser]);

  return [loading, user];
};

export const useAuthUser = (): AuthUser | null => {
  const { user } = useContext<AppContextPropsType>(AppContext);
  if (user) {
    return user;
  }
  return null;
};

export const getUserToken = () => {

  let PatientDetails = localStorage.getItem('PatientDetails');
  let token = '';
  let userdetails: any;
  if (PatientDetails) {
    userdetails = JSON.parse(PatientDetails);
    token = userdetails['identificationKey'];
  }

  return token;
}

export const getUserName = () => {

  let PatientDetails = localStorage.getItem('PatientDetails');
  let userName = '';
  let userdetails: any;
  if (PatientDetails) {
    userdetails = JSON.parse(PatientDetails);
    userName = userdetails['firstName'] + " " + userdetails['lastName'];
  }

  return userName;
}
export const getUserEmail = () => {

  let PatientDetails = localStorage.getItem('PatientDetails');
  let email = '';
  let userdetails: any;
  if (PatientDetails) {
    userdetails = JSON.parse(PatientDetails);
    email = userdetails['email'];;
  }

  return email;
}

export const getUserId = () => {
  let PatientDetails = localStorage.getItem('PatientDetails');
  if (PatientDetails) {
    const details = JSON.parse(PatientDetails);
    return details.identificationKey || details.id || details.docid || "";
  }
  return "";
}

export const getPatientDocId = () => {
  let PatientDetails = localStorage.getItem('PatientDetails');
  if (PatientDetails) {
    const details = JSON.parse(PatientDetails);
    return details.docid || details.id || "";
  }
  return "";
}